// extracted by mini-css-extract-plugin
export default {"background":"Admin_background__t-34N","container":"Admin_container__wm-Lk","pageTitle":"Admin_pageTitle__KhOPV","sectionHeader":"Admin_sectionHeader__JjqpM"};